<template>
  <PlayerAvatarList
    v-model="players"
    :minCount="run.min_player_count || 0"
    :isActive="!run.canceled_at"
  />
</template>

<script setup lang="ts">
import PlayerAvatarList from "@/components/PlayerAvatarList.vue";
import { PlayerSummary, RunSummary, StatusSummaryWithPlayer } from "@shared/lib/database/query.types";
import { parseISO } from "date-fns";
import { computed } from "vue";

const run = defineModel<RunSummary & {
  statuses: Array<StatusSummaryWithPlayer>,
}>({
  required: true,
});

const players = computed(() => {
  return [...run.value.statuses].sort(sortByUpdated).reduce<Array<PlayerSummary>>((acc, status) => {
    if (status.probability === 1 && status.player) acc.push(status.player);

    return acc;
  }, []);
});

function sortByUpdated (a: {
  created_at: string,
  updated_at: string,
}, b: {
  created_at: string,
  updated_at: string,
}) {
  return +parseISO(a.updated_at || a.created_at) - +parseISO(b.updated_at || b.created_at);
}
</script>
